/**
 * @module ol/interaction/Property
 */

/**
 * @enum {string}
 */
export default {
  ACTIVE: 'active'
};

//# sourceMappingURL=Property.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/interaction/Property.js
// module id = 79
// module chunks = 0